<template>
    <section class="div-estacao">
        <div class="card-estacao-inline">
            <div>
                <img src="/images/icons/estacao/sol.png" alt="temperatura" id="imgTemp" style="width: 19px"/>
                <span class="estacao_temperatura">{{ estacao ? estacao.temperatura : "--"}}°C</span>&nbsp;
            </div>
            <div>
                <img src="/images/icons/estacao/umidade.png" alt="umidade" id="imgUmidade" style="width: 19px" />
                <span class="estacao_umidade">{{estacao ? estacao.umidade : "--"}}%</span>&nbsp;
            </div>
        </div>
        <div class="card-estacao-inline">
            <div>
                <img src="/images/icons/estacao/nuvem.png" alt="chuva" id="imgChuva" style="width: 19px"/>
                <span class="estacao_chuva">{{ estacao && estacao.chuva > 0 ? "Chovendo" : "Sem chuva" }}</span>&nbsp;
            </div>
            <!-- <div>
                <img src="/images/icons/estacao/pluviometro.png" alt="pluv" id="imgPluviometro" style="width: 19px"/>
                <span class="estacao_pluviometro">{{ estacao ? estacao.pluviometro : "--"}}mm</span>
            </div> -->
        </div>
        <div id="estacao_estacao">
            Estação {{ estacao ? estacao.estacao : "--" }} - {{ estacao ? dataFormatada(estacao.data) : "--" }}
        </div>
        <hr>
    </section>
</template>
<script>
export default {
    name: "EstacaoComponent",
    props: {
        estacao: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },

    methods: {
        dataFormatada(data) {
            const date = new Date(data);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        },
    },
};
</script>
<style scoped>
    .div-estacao {
        background-color: #fff;
        height: auto;
        padding: 0.2em;
        align-content: center;
        align-items: center;
        width: auto;
        margin: 2vh;
        color: black;
        font-size: 1em;
        font-weight: bolder;
        text-transform: capitalize;
    }

    .card-estacao-inline {
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 5px;
    }

    #estacao_estacao {
        font-size: 0.7em;
        text-align: center;
    }
</style>
